import { RouteRecordRaw } from "vue-router";
import useTrackerStore from "@/stores/trackers";
import { RUDDERSTACK_EVENTS } from "@/lib/rudderstack";

const VisibilityPage = () => import("@/pages/visibility/VisibilityPage.vue");
const AssetDetails = () => import("@/components/visibility/assets/asset_details/AssetDetails.vue");
const ShipmentsPage = () => import("@/pages/visibility/ShipmentsPage.vue");

const routes: RouteRecordRaw = {
  name: "visibilityPage",
  path: "/visibility",
  component: VisibilityPage,
  props: true,
  meta: {
    authenticated: true,
    permissions: ["visibility_asset_list"],
    breadcrumbs: [
      { label: "Visibility" },
      { label: "Assets", to: "assetsList", on: ["assetsList", "assetLookup", "assetDetails"] },
      { label: "Asset Details", to: "assetDetails", on: ["assetDetails"] },
      { label: "Bulk Search", to: "assetLookup", on: ["assetLookup"] },
    ],
  },
  children: [
    {
      name: "shipmentsDashboard",
      path: ":customerId/shipments",
      props: true,
      component: ShipmentsPage,
      meta: {
        title: "Shipment Visibility",
      },
    },
    {
      name: "assetsList",
      path: ":customerId/assets",
      redirect: { name: "shipmentsDashboard" },
    },
    {
      name: "assetDetails",
      path: ":customerId/waybills/:waybillId",
      props: true,
      components: {
        default: AssetDetails,
      },
      beforeEnter: async (to) => {
        // if (to.query.sort_column) {
        //   assetsStore.sortColumn = to.query.sort_column.toString();
        // }
        if (to.query.widget) {
          const trackers = useTrackerStore();
          trackers.logRudderstackEvent(RUDDERSTACK_EVENTS.DASHBOARD_WIDGET_VISIT_ASSET_DETAILS, {
            waybill_id: to.params.waybillId as string,
            widget: to.query.widget as string,
          });
        }
        // if (to.query.sort_direction) {
        //   assetsStore.sortDirection = to.query.sort_direction.toString() as "ASC" | "DESC";
        // }
      },
    },
  ],
};

export default routes;
